<template>
    <div class="d-flex">
        <el-input
            class=""
            v-model="name"
            placeholder="ENTER NEW GROUP NAME"
        ></el-input>
        <button
            class="btn btn-purple ml-2"
            @click="create"
        >CREATE</button>
    </div>
</template>

<script>
  import eventBus from "../../event-bus";
  import {modes} from "../send-list/types";

  export default {
    props: {
      createUrl: String,
    },

    data() {
      return {
        name: '',
      };
    },

    methods: {
        create() {
          eventBus.$emit('show-send-list-modal-form', {
            url: this.createUrl,
            model: _.assign({}, this.name ? {name: this.name} : {}),
            title: 'NEW GROUP',
            mode: this.name ? modes.simple : modes.normal,
          });
          this.name = '';
        },
    },
  }
</script>

<style scoped>

</style>
